import {
  authReq
} from '@/utils/http'

const getAgents = (page = 1, pageSize = 10, sort = '', filters = {}) => {
  return authReq.get('/api/v1/agent', {
    'page_size': pageSize,
    page,
    sort,
    ...filters
  })
}

export default {
  getAgents
}



// WEBPACK FOOTER //
// ./src/api/agentApi.js